import { Component, OnInit } from '@angular/core';
import { ResolutionService } from '@app/core/services/resolution/resolution.service';
import { Router, NavigationEnd } from '@angular/router';
import { links as headerComponentLinks } from './header.component.links';
import { Store, select } from '@ngrx/store';
import { AppState, selectAuthState } from '@app/store/store.states';
import { Observable } from 'rxjs';
import { User } from '../models/user/user.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  links = headerComponentLinks;

  isMenuOpen = false;

  currentPageTitle = 'Portal do cliente';

  currentUser: Observable<User>;

  constructor(
    private readonly store: Store<AppState>,
    private readonly resolutionService: ResolutionService,
    private readonly router: Router
  ) {
    this.router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationEnd) {
        this.closeMenu();

        this.unExpandSecondaryLinks();
      }
    });
  }

  ngOnInit() {
    this.currentUser = this.store.pipe(
      select(selectAuthState),
      map(({ user }) => user)
    );
  }

  toggleUserProfileMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  unExpandSecondaryLinks() {
    this.links.secondary = this.links.secondary.map((link) => {
      if (link.expanded) {
        link.expanded = false;
      }

      return link;
    });
  }

  async closeMenu() {
    if (this.isMenuOpen === true) {
      this.isMenuOpen = false;
    }
  }

  get displaySideNavMenu(): boolean {
    return this.resolutionService.isTablet;
  }

  get isUserAuthenticatedAndUserVerified() {
    return this.currentUser.pipe(map((user) => user && !user.firstAccess));
  }
}
